import { saveToStorage, loadFromStorage } from '@/util/saveStore'

const saveVideo = function(name,video) {
  const videoHistory = loadFromStorage(name, [])
  insertArray(videoHistory, video)
  saveToStorage(name, videoHistory)
}
function insertArray(arr, item) {
  const index = arr.findIndex(i => {
    return i.name === item.name
  })
  if (index < 0) {
    arr.push(item)
  }
}
const loadVideoHitory = function(data) {
    return loadFromStorage(data.deviceName,[])
}
export { saveVideo,loadVideoHitory }
